import styled from 'styled-components';

export const Container = styled.div`
  padding: 0;
  display: flex;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
`;
